import ToggleButtonComponent from "components/ToggleButton/ToggleButton";
import HelperIcon from "components/HelperIcon/HelperIcon";
import InfoTooltip from "../../../components/Tooltip/InfoTooltip";
import {
  CustomModal,
  ModalInputSection,
} from "custom_modules/Leave/applyLeaveModalStyles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalBody } from "reactstrap";
import {
  CardTitle,
  CommonFlex,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  RedStar,
} from "styledComponents/common";

import { PrimaryButton, WhiteButton } from "../../../styledComponents/buttons";

const AddSubTaskModal = ({
  isOpen,
  toggle,
  setSubTaskList,
  subTaskList,
  onSubTaskAdd,
}) => {
  const { t } = useTranslation();
  const [subTaskName, setSubTaskName] = useState("");
  const [subTaskDescription, setSubTaskDescription] = useState("");
  const [isAllowedEvidences, setIsAllowedEvidences] = useState(false);
  const [saveErrors, setSaveErrors] = useState({});

  const generateSubTaskId = () =>
    `${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;

  const resetForm = () => {
    setSubTaskName("");
    setSubTaskDescription("");
    setIsAllowedEvidences(false);
    setSaveErrors({});
  };

  const handleSubmit = () => {
    const errors = {};
    let isValid = true;

    if (!subTaskName.trim()) {
      errors.subTaskName = "Subtask name is required";
      isValid = false;
    }

    if (!subTaskDescription.trim()) {
      errors.subTaskDescription = "Subtask description is required";
      isValid = false;
    }

    setSaveErrors(errors);

    if (!isValid) {
      return;
    }

    const newSubtask = {
      name: subTaskName.trim(),
      description: subTaskDescription.trim(),
      allow_evidences: isAllowedEvidences,
      isAllowedEvidences: isAllowedEvidences,
    };

    if (onSubTaskAdd) {
      onSubTaskAdd(newSubtask);
    } else {
      setSubTaskList([
        ...subTaskList,
        {
          ...newSubtask,
          id: generateSubTaskId(),
        },
      ]);
    }

    resetForm();
    toggle();
  };

  const handleCancel = () => {
    resetForm();
    toggle();
  };

  return (
    <CustomModal isOpen={isOpen} toggle={toggle}>
      <ModalBody style={{ padding: `30px` }}>
        <CommonFlex gap="4px" disableResponsive>
          <CardTitle>{t("add_subtask")}</CardTitle>
          <HelperIcon
            text={t("break_down_your_task_into_individual_steps_for_ease_of_track_keeping")}
          />
        </CommonFlex>
        <ModalInputSection>
          <InputLabel>
            Subtask Name <RedStar>*</RedStar>
          </InputLabel>
          <InputField
            type="text"
            placeholder="Enter Subtask Name"
            value={subTaskName}
            onChange={e => {
              setSubTaskName(e.target.value);
              if (saveErrors.subTaskName) {
                const errors = { ...saveErrors };
                delete errors.subTaskName;
                setSaveErrors(errors);
              }
            }}
            style={
              saveErrors &&
              saveErrors[`subTaskName`] && {
                border: `1px solid #fe5969`,
                backgroundColor: `rgba(252, 87, 104, 0.05)`,
              }
            }
          />
          {saveErrors && saveErrors.subTaskName && (
            <FormAlert>{saveErrors.subTaskName}</FormAlert>
          )}
        </ModalInputSection>
        <ModalInputSection>
          <InputLabel>
            Subtask Description <RedStar>*</RedStar>
          </InputLabel>
          <InputTextArea
            text="Description"
            cols="35"
            rows="3"
            value={subTaskDescription}
            placeholder="Enter Subtask Description"
            onChange={e => {
              setSubTaskDescription(e.target.value);
              if (saveErrors.subTaskDescription) {
                const errors = { ...saveErrors };
                delete errors.subTaskDescription;
                setSaveErrors(errors);
              }
            }}
            height="auto"
            style={
              saveErrors &&
              saveErrors[`subTaskDescription`] && {
                border: `1px solid #fe5969`,
                backgroundColor: `rgba(252, 87, 104, 0.05)`,
              }
            }
          />
          {saveErrors && saveErrors.subTaskDescription && (
            <FormAlert>{saveErrors.subTaskDescription}</FormAlert>
          )}
        </ModalInputSection>
        <ModalInputSection>
          <CommonFlex disableResponsive alignItems="center" gap="4px">
            <InputLabel>{t("require_evidence")}</InputLabel>
            <HelperIcon text={t("use_this_to_check_whether_this_task_needs_supporting_evidence")} />
            <ToggleButtonComponent
              active={isAllowedEvidences}
              handleClick={() => setIsAllowedEvidences(!isAllowedEvidences)}
              width="30px"
              height="16px"
              circleSize="10px"
            />
          </CommonFlex>
        </ModalInputSection>
        <CommonFlex disableResponsive justifyContent="flex-end" margin="20px 0 0" gap="10px">
          <WhiteButton type="cancel" onClick={handleCancel}>
            Cancel
          </WhiteButton>
          <PrimaryButton onClick={handleSubmit}>Add Subtask</PrimaryButton>
        </CommonFlex>
      </ModalBody>
    </CustomModal>
  );
};

export default AddSubTaskModal;
